module.exports = __webpack_public_path__ + "img/199.5d2f3e94.jpg";